/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Persondidacquisitionmeeting3Inputs */

const de__field_persondidacquisitionmeeting3 = /** @type {(inputs: _Field_Persondidacquisitionmeeting3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akquisegespräch-Person`)
};

/**

* @param {_Field_Persondidacquisitionmeeting3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_persondidacquisitionmeeting3 = /** @type {((inputs?: _Field_Persondidacquisitionmeeting3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Persondidacquisitionmeeting3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_persondidacquisitionmeeting3(inputs)
});
export { _field_persondidacquisitionmeeting3 as "_field_personDidAcquisitionMeeting" }